import httpClient from "@/http-client";

export const get = (requestId, options = {}) => {
    return httpClient
        .get(`/api/customer-loan-requests/${requestId}/attachments`, options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const uploadFile = file => {
    const formData = new FormData();
    formData.append('file', file);

    return httpClient
        .post('/api/customer-loan-requests/attachments/upload-file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = (requestId, data) => {
    return httpClient
        .post(`/api/customer-loan-requests/${requestId}/attachments`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = attachmentId => {
    return httpClient
        .delete(`/api/customer-loan-requests/attachments/${attachmentId}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const removeFile = filePath => {
    return httpClient
        .get('/api/customer-loan-requests/attachments/remove-file', {
            params: { file_path: filePath }
        })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default { get, uploadFile, store, destroy, removeFile };
